







































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import type { FormLoja } from '@/models'
import { obrigatorio } from '@/shareds/regras-de-form'
import CamposDeEndereco from '@/components/ui/CamposDeEndereco.vue'
import CampoDeTelefone from '@/components/ui/CampoDeTelefone.vue'

@Component({
	components: { CamposDeEndereco, CampoDeTelefone },
})
export default class SecaoEnderecoEContato extends Vue {
	@Prop({ type: Object, required: true }) loja!: FormLoja
	@Ref() camposDeTelefones!: CampoDeTelefone[]

	obrigatorio = obrigatorio

	adicionarTelefone() {
		this.loja.telefones.push('')
		this.$nextTick(() => {
			const campo = this.camposDeTelefones[this.loja.telefones.length - 1]
			if (campo) (campo.$children[0] as unknown as HTMLElement).focus()
		})
	}
}
